import React, { useEffect, useState } from "react";
import { POST_APPOINTMENT_PAYMENT } from "../../queries";
import { useMutation } from "@apollo/react-hooks";
import { useParams, Redirect } from "react-router-dom";
import * as queryString from "query-string";
import { useSnackbar } from "notistack";
import { Loader } from "../../components";
import { Typography, Box } from "@material-ui/core";

const DEFAULT_ERROR_MSG = "Payment was unsuccessful";

const AppointmentPaySuccess = () => {
  const { appointment_id = "" } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const { token = "" } = queryString.parse(window.location.search);

  const [payment, setPayment] = useState();

  /**
   * Post finalize payment
   */
  const [postAppointmentPayment, { loading }] = useMutation(
    POST_APPOINTMENT_PAYMENT,
    {
      onCompleted: ({ payment }) => {
        if (payment && payment.status && payment.status === "success") {
          setPayment({
            status: "success"
          });

          enqueueSnackbar("Appointment scheduled successfully", {
            variant: "success"
          });
        } else {
          setPayment({
            status: "error",
            msg: `${DEFAULT_ERROR_MSG}. API error (1).`
          });
        }
      },
      onError: () =>
        setPayment({
          status: "error",
          msg: `${DEFAULT_ERROR_MSG}. API error (2).`
        })
    }
  );

  /**
   * Handle update of payment on mount
   */
  useEffect(() => {
    if (appointment_id && token) {
      postAppointmentPayment({
        variables: {
          body: {
            appointment_id,
            receipt_token: token
          }
        }
      });
    } else {
      setPayment({
        status: "error",
        msg: `${DEFAULT_ERROR_MSG}. Missing token.`
      });
    }
  }, []);

  if (loading || !payment) return <Loader />;

  return payment.status === "success" ? (
    <Redirect to="/" />
  ) : (
    <Box p={2}>
      <Typography color="error">{payment.msg || DEFAULT_ERROR_MSG}</Typography>
    </Box>
  );
};

export { AppointmentPaySuccess };
